var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// ../js/~/core-js/library/modules/_has.js
// module id = 65
// module chunks = 0